var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LinkedIn",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    "data-name": "Path 4040",
    d: "M382.854,288.094a10,10,0,1,1,10-10A10.012,10.012,0,0,1,382.854,288.094Zm0-18.924a8.924,8.924,0,1,0,8.924,8.924A8.934,8.934,0,0,0,382.854,269.17Z",
    transform: "translate(-372.854 -268.094)",
    fill: "#006341"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(5.633 7.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    "data-name": "Path 4041",
    d: "M396.818,291.923V295.4a.155.155,0,0,1-.155.155h-1.794a.155.155,0,0,1-.156-.155v-3.231c0-.85-.3-1.431-1.066-1.431a1.151,1.151,0,0,0-1.079.769,1.436,1.436,0,0,0-.07.513v3.38a.156.156,0,0,1-.156.155H390.55a.155.155,0,0,1-.155-.155c0-.861.022-5.036,0-6.017a.155.155,0,0,1,.155-.157h1.79a.156.156,0,0,1,.155.156v.742c0,.007-.01.014-.014.021h.014v-.021a2.09,2.09,0,0,1,1.9-1.046c1.385,0,2.423.9,2.423,2.849Zm-9.537,3.63h1.793a.155.155,0,0,0,.155-.155v-6.019a.156.156,0,0,0-.155-.156h-1.793a.156.156,0,0,0-.155.156V295.4A.155.155,0,0,0,387.281,295.553Z",
    transform: "translate(-387.126 -289.074)",
    fill: "#006341"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    transform: "translate(5.139 4.617)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 1.127,
    cy: 1.127,
    r: 1.127,
    fill: "#006341"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFooter);
export default __webpack_public_path__ + "static/media/linkedin-footer.ff43f569457495a45aa1950b84e17968.svg";
export { ForwardRef as ReactComponent };